import * as Types from '../graphql.generated';

import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type GetAbTestsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAbTestsQuery = { __typename?: 'Query' } & {
    abTests?: Types.Maybe<
        Array<{ __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'name'>>
    >;
};

export const GetAbTestsDocument = gql`
    query getABTests {
        abTests {
            id
            name
        }
    }
`;

/**
 * __useGetAbTestsQuery__
 *
 * To run a query within a React component, call `useGetAbTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbTestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAbTestsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAbTestsQuery,
        GetAbTestsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAbTestsQuery, GetAbTestsQueryVariables>(
        GetAbTestsDocument,
        options
    );
}
export function useGetAbTestsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAbTestsQuery,
        GetAbTestsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAbTestsQuery, GetAbTestsQueryVariables>(
        GetAbTestsDocument,
        options
    );
}
export type GetAbTestsQueryHookResult = ReturnType<typeof useGetAbTestsQuery>;
export type GetAbTestsLazyQueryHookResult = ReturnType<
    typeof useGetAbTestsLazyQuery
>;
export type GetAbTestsQueryResult = Apollo.QueryResult<
    GetAbTestsQuery,
    GetAbTestsQueryVariables
>;
